var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"multiple":"","outlined":"","label":"Rolle","items":_vm.roles,"item-text":"display","item-value":"name","placeholder":"Rolle"},model:{value:(_vm.userC.role),callback:function ($$v) {_vm.$set(_vm.userC, "role", $$v)},expression:"userC.role"}})
}
var staticRenderFns = []

export { render, staticRenderFns }